import React from "react";
import "./Header.scss";
import { Menu, Hero } from "../";

const Header = () => {
    return (
        <div className="header">
            <div className="header__filter">
                <Hero />
            </div>
        </div>
    )
}

export default Header;
